module.exports = __webpack_public_path__ + "static/media/FriendsMedia.853b192f.PNG";